import axios from './axios';

export default {
  list(page, kind, subject) {
    return axios.get('/documents', { params: { page, kind, subject } });
  },
  subjects() {
    return axios.get('/documents/subjects');
  },
  listPlannings() {
    return axios.get('/documents?kind=Plannings');
  },
  get(id) {
    return axios.get(`/documents/${id}`);
  },
};
